export const CURRENT_USER_STORAGE = 'currentUser'
export const PENDING_COMPANY_STORAGE = 'pulse:pendingCompany'
export const PENDING_CHECKOUT_STORAGE = 'pulse:pendingCheckout'
